export const menuTranslations = {
  fr: {
    nav: {
      solutions: 'Nos solutions',
      sectors: 'Votre secteur',
      problems: 'Votre besoin',
      forWhom: 'Votre profil',
      situation: 'Votre situation',
      whyConsultic: 'Pourquoi ConsulTIC',
      servicesSupport: 'Services et Support',
      resources: 'Ressources',
      contact: 'Contact',
    },
    sectorsMenu: {
      title: 'SECTEURS À FORTE EXIGENCE IT',
      description: 'Solutions adaptées à votre secteur d\'activité',
      hub: 'Voir tous les secteurs',
      items: {
        comptables: 'Comptables & Fiduciaires',
        medical: 'Médical & Paramédical',
        juridique: 'Cabinets Juridiques',
        pme: 'PME de Services',
        multisite: 'Entreprises Multi-sites',
        reglemente: 'Professions Réglementées',
      }
    },
    problemsMenu: {
      title: 'VOTRE BESOIN',
      description: 'Identifiez vos défis IT',
      hub: 'Voir tous les besoins',
      items: {
        instable: 'Informatique stable',
        reactivite: 'Réactivité du support',
        securite: 'Sécurité des données',
        couts: 'Coûts prévisibles',
        dependance: 'Indépendance prestataire',
        interne: 'Gestion interne simplifiée',
      }
    },
    rolesMenu: {
      title: 'VOTRE PROFIL',
      description: 'Solutions adaptées à votre rôle',
      hub: 'Voir tous les profils',
      items: {
        ceo: 'Dirigeant / CEO',
        cfo: 'Directeur Financier / CFO',
        it: 'Responsable IT',
        partner: 'Devenir partenaire',
        editor: 'Éditeur logiciel',
      }
    },
    whyMenu: {
      title: 'POURQUOI CONSULTIC',
      description: 'Ce qui nous différencie',
      items: {
        approach: 'Notre approche',
        engagements: 'Nos engagements',
        security: 'Sécurité & Disponibilité',
        support: 'Support & Accompagnement',
        testimonials: 'Témoignages clients',
      }
    },
    footer: {
      solutions: 'Solutions',
      sectors: 'Secteurs',
      situation: 'Votre situation',
      whyUs: 'Pourquoi ConsulTIC',
      resources: 'Ressources',
      legal: 'Légal',
    }
  },
  nl: {
    nav: {
      solutions: 'Onze oplossingen',
      sectors: 'Sectoren',
      problems: 'Uw behoefte',
      forWhom: 'Uw profiel',
      situation: 'Uw situatie',
      whyConsultic: 'Waarom ConsulTIC',
      servicesSupport: 'Services en Support',
      resources: 'Bronnen',
      contact: 'Contact',
    },
    sectorsMenu: {
      title: 'SECTOREN MET HOGE IT-EISEN',
      description: 'Oplossingen aangepast aan uw sector',
      hub: 'Alle sectoren bekijken',
      items: {
        comptables: 'Accountants & Fiduciaires',
        medical: 'Medisch & Paramedisch',
        juridique: 'Advocatenkantoren',
        pme: 'Diensten KMO\'s',
        multisite: 'Multi-site Bedrijven',
        reglemente: 'Gereglementeerde Beroepen',
      }
    },
    problemsMenu: {
      title: 'UW BEHOEFTE',
      description: 'Identificeer uw IT-uitdagingen',
      hub: 'Alle behoeften bekijken',
      items: {
        instable: 'Stabiele IT',
        reactivite: 'Reactieve support',
        securite: 'Gegevensbeveiliging',
        couts: 'Voorspelbare kosten',
        dependance: 'Onafhankelijkheid leverancier',
        interne: 'Vereenvoudigd intern IT-beheer',
      }
    },
    rolesMenu: {
      title: 'UW PROFIEL',
      description: 'Oplossingen aangepast aan uw rol',
      hub: 'Alle profielen bekijken',
      items: {
        ceo: 'Directeur / CEO',
        cfo: 'Financieel Directeur / CFO',
        it: 'IT Manager',
        partner: 'Partner worden',
        editor: 'Softwareontwikkelaar',
      }
    },
    whyMenu: {
      title: 'WAAROM CONSULTIC',
      description: 'Wat ons onderscheidt',
      items: {
        approach: 'Onze aanpak',
        engagements: 'Onze engagementen',
        security: 'Beveiliging & Beschikbaarheid',
        support: 'Support & Begeleiding',
        testimonials: 'Klantgetuigenissen',
      }
    },
    footer: {
      solutions: 'Oplossingen',
      sectors: 'Sectoren',
      situation: 'Uw situatie',
      whyUs: 'Waarom ConsulTIC',
      resources: 'Bronnen',
      legal: 'Juridisch',
    }
  },
  en: {
    nav: {
      solutions: 'Our Solutions',
      sectors: 'Sectors',
      problems: 'Your Needs',
      forWhom: 'Your Profile',
      situation: 'Your Situation',
      whyConsultic: 'Why ConsulTIC',
      servicesSupport: 'Services & Support',
      resources: 'Resources',
      contact: 'Contact',
    },
    sectorsMenu: {
      title: 'HIGH IT DEMAND SECTORS',
      description: 'Solutions tailored to your industry',
      hub: 'View all sectors',
      items: {
        comptables: 'Accountants & Fiduciaries',
        medical: 'Medical & Healthcare',
        juridique: 'Law Firms',
        pme: 'Service SMEs',
        multisite: 'Multi-site Companies',
        reglemente: 'Regulated Professions',
      }
    },
    problemsMenu: {
      title: 'YOUR NEEDS',
      description: 'Identify your IT challenges',
      hub: 'View all challenges',
      items: {
        instable: 'Stable IT',
        reactivite: 'Responsive support',
        securite: 'Data security',
        couts: 'Predictable costs',
        dependance: 'Provider independence',
        interne: 'Simplified IT management',
      }
    },
    rolesMenu: {
      title: 'YOUR PROFILE',
      description: 'Solutions tailored to your role',
      hub: 'View all profiles',
      items: {
        ceo: 'Executive / CEO',
        cfo: 'CFO / Finance Director',
        it: 'IT Manager',
        partner: 'Become a partner',
        editor: 'Software editor',
      }
    },
    whyMenu: {
      title: 'WHY CONSULTIC',
      description: 'What sets us apart',
      items: {
        approach: 'Our approach',
        engagements: 'Our commitments',
        security: 'Security & Availability',
        support: 'Support & Guidance',
        testimonials: 'Client testimonials',
      }
    },
    footer: {
      solutions: 'Solutions',
      sectors: 'Sectors',
      situation: 'Your Situation',
      whyUs: 'Why ConsulTIC',
      resources: 'Resources',
      legal: 'Legal',
    }
  }
};
